import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-md-3\"><div class=\"icobox\"><div class=\"icobox__icon-wrapper\"><div class=\"icobox__icon\"><i class=\"fas fa-users\"></i></div></div><h3 class=\"icobox__title\">Booking Size</h3><div class=\"icobox__desc\"> You must have at least two people on your team, with the maximum depending on the selected game. </div></div></div><div class=\"col-md-3\"><div class=\"icobox\"><div class=\"icobox__icon-wrapper\"><div class=\"icobox__icon\"><i class=\"fas fa-clock\"></i></div></div><h3 class=\"icobox__title\">Game Length</h3><div class=\"icobox__desc\"> Each booking will last for a total of 90 minutes including a briefing, the playing of the game and a debriefing including a team photo! </div></div></div><div class=\"col-md-3\"><div class=\"icobox\"><div class=\"icobox__icon-wrapper\"><div class=\"icobox__icon\"><i class=\"fas fa-money-check-alt\"></i></div></div><h3 class=\"icobox__title\">Pricing</h3><div class=\"icobox__desc\"> The number of players defines the price, the more people on your team the cheaper it will be! Starting from <strong>£14</strong></div></div></div><div class=\"col-md-3\"><div class=\"icobox\"><div class=\"icobox__icon-wrapper\"><div class=\"icobox__icon\"><i class=\"fas fa-trophy\"></i></div></div><h3 class=\"icobox__title\">Head-To-Head</h3><div class=\"icobox__desc\"> Go Head-To-Head with our brand new game, The Empty Cabin. Book both rooms for the same time slot to go Head-To-Head. </div></div></div></div>", 1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-4 ml-md-auto mr-md-auto" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h4", { class: "text-center" }, "Price List", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("ul", { class: "list no-icon" }, [
  /*#__PURE__*/_createVNode("li", null, "Team of 2 - £55 (£27.50/person)"),
  /*#__PURE__*/_createVNode("li", null, "Team of 3 - £66 (£22/person)"),
  /*#__PURE__*/_createVNode("li", null, "Team of 4 - £75 (£18.75/person)"),
  /*#__PURE__*/_createVNode("li", null, "Team of 5 - £84 (£16.80/person)"),
  /*#__PURE__*/_createVNode("li", null, "Team of 6 - £93 (£15.5/person)")
], -1)
const _hoisted_6 = {
  key: 0,
  class: "text-center"
}
const _hoisted_7 = {
  key: 0,
  target: "_blank",
  href: "https://redrobotsystems.resova.co.uk/gift-voucher",
  class: "btn btn-lg btn-primary"
}
const _hoisted_8 = {
  key: 1,
  target: "_blank",
  href: "https://pehexham.resova.co.uk/gift-voucher",
  class: "btn btn-lg btn-primary"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "text-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: "/img/sectigo.png",
    alt: "Secured by Sectigo"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        (_ctx.voucherLink)
          ? (_openBlock(), _createBlock("p", _hoisted_6, [
              (_ctx.location === 'middlesbrough')
                ? (_openBlock(), _createBlock("a", _hoisted_7, "Purchase Gift Vouchers"))
                : _createCommentVNode("", true),
              (_ctx.location === 'hexham')
                ? (_openBlock(), _createBlock("a", _hoisted_8, "Purchase Gift Vouchers"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _hoisted_9
      ])
    ])
  ]))
}